<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="max-h-screen rounded bg-white shadow  overflow-auto">
			<h1 class="text-center text-2xl font-bold mb-4 text-white p-4 bg-red-600">
				Please check your order before submitting
			</h1>
			<div class="px-4">
				<div class="text-gray-700 mb-6">
					<div class="" v-if="initObject.phases" v-for="(phase, phaseName) in initObject.phases">
						<p class="font-bold">Phase {{ phaseName }}</p>
						<template v-if="phase.areas">
							<div class="font-bold text-sm ml-2 mt-2" v-for="area in phase.areas">
								Area {{ area.name }}
								<template v-if="area.products.length">
									<div class="font-normal ml-4 flex items-center justify-between mt-1" v-for="product in area.products">
										<div>{{ product.name }}</div>
										<div>{{ product.qty }}</div>
									</div>
								</template>
							</div>
						</template>
						<template v-if="phase.products">
							<div class="ml-2 mt-2 text-xs">General</div>
							<div class="font-bold text-sm ml-2 mt-1">
								<div class="font-normal flex items-center justify-between mt-1" v-for="product in phase.products">
									<div>{{ product.name }}</div>
									<div>{{ product.qty }}</div>
								</div>
							</div>
						</template>
						<template v-if="phase.carports">
							<div class="ml-2 mt-2 text-xs">Carports</div>
							<div class="font-bold text-sm ml-2 mt-1">
								<div class="font-normal flex items-center justify-between mt-1" v-for="product in phase.carports">
									<div>{{ product.name }}</div>
									<div>{{ product.qty }}</div>
								</div>
							</div>
						</template>
						<template v-if="phase.blocks">
							<div class="font-bold text-sm ml-2 mt-2" v-for="(block, blockName) in phase.blocks">
								Block {{ blockName }}
								<template v-if="block.first_fix">
									<div class="text-xs font-normal ml-4 mt-1">first fix</div>
									<div class="font-normal ml-4 flex items-center justify-between mt-1" v-for="product in block.first_fix">
										<div>{{ product.name }} <span class="text-gray-400" v-if="product.floor !== undefined"> {{ floors[product.floor] }} floor </span></div>
										<div>{{ product.qty }}</div>
									</div>
								</template>
								<template v-if="block.wire">
									<div class="text-xs font-normal ml-4 mt-1">wire</div>
									<div class="font-normal ml-4 flex items-center justify-between mt-1" v-for="product in block.wire">
										<div>{{ product.name }}</div>
										<div>{{ product.qty }}</div>
									</div>
								</template>
								<template v-if="block.units">
									<div class="text-xs font-normal ml-4 mt-1">Final fix</div>
									<div class="font-normal ml-4 mt-1" v-for="(unit, index) in block.units">
										<p  class="flex items-center space-x-2 cursor-pointer" @click="showUnit(unit.products, index, phaseName, blockName)">
											<chevron-component width="w-3" height="h-3" :show="currentUnit == index"></chevron-component>
											Unit {{ unit.name }}
										</p>
										<template v-if="currentUnit == index" v-for="product in unit.products">
											<div class="font-normal ml-4 flex items-center justify-between mt-1">
												<div>{{ product.name }}</div>
												<div>{{ product.qty }}</div>
											</div>
										</template>
									</div>
								</template>
								<template v-if="block.common">
									<div class="text-xs font-normal ml-4 mt-1">common</div>
									<div class="font-normal ml-4 flex items-center justify-between mt-1" v-for="product in block.common">
										<div>{{ product.name }}</div>
										<div>{{ product.qty }}</div>
									</div>
								</template>
							</div>
						</template>
					</div>
					<div class="" v-if="initObject.tools">
						<p class="font-bold">Tools and Consumables</p>
						<template v-if="initObject.tools.length">
							<div class="font-normal ml-4 flex items-center justify-between mt-1" v-for="product in initObject.tools">
								<div>{{ product.name }}</div>
								<div>{{ product.qty }}</div>
							</div>
						</template>
					</div>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link link-red" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="confirm">Submit order</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['show', 'theObject', 'term'],
	data () {
		return {
			initObject: this.theObject,
			initTerm: this.term || 'Deleting',
			currentUnit: null,
			unitsLoaded: [],
			floors: [
				'ground',
				'first',
				'second',
				'third',
				'fourth',
				'fifth',
			],
		}
	},
	methods: {
		cancel () {
			this.$emit('close')
		},
		confirm () {
			this.$emit('confirm', this.initObject)
		},
		getProductsFromAPI(products) {
			return this.$http.get('/products', {
				params: {
					ids: products,
				}
			});
		},
		showUnit(products,unitIndex,phaseName,blockName){
			let productObject = {};
			products.forEach(pdt => {
				productObject[Object.keys(pdt)[0]] = pdt[Object.keys(pdt)[0]];
			});
			
			
			if(this.currentUnit == unitIndex){
				this.currentUnit = null;
				return;
			}
			let alreadyLoaded = Object.values(products)[0]['name'];
			
			//let alreadyLoaded = productObject[Object.keys(productObject)[0]].name ? true : false;
			if(! alreadyLoaded){

				this.getProductsFromAPI(Object.keys(productObject))
					.then(response => {
						let fetchedProducts = this.$_.map(productObject, (qty, prodId) => {
							let filtered = response.data.products.filter(prod => {
								return prod.id == prodId;
							});
							if(! filtered.length){
								console.log(prodId);
							}
							return {
								'id': filtered[0].id,
								'name': filtered[0].name,
								'qty': qty,
							};
						});
						this.unitsLoaded.push(unitIndex);
						this.$set(this.initObject.phases[phaseName].blocks[blockName]['units'][unitIndex], 'products', fetchedProducts);
					})
			}
			this.currentUnit = unitIndex;
		}
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		})
	}
}
</script>
